
import draggable from 'vuedraggable';
import { v4 as uuid } from 'uuid';
import Vue from "vue";
import CheckboxGroupBuilder from "@/components/form/fields/checkbox_group/CheckboxGroupBuilder.vue";
import DatePickerBuilder from "@/components/form/fields/date_picker/DatePickerBuilder.vue";
import DropdownBuilder from "@/components/form/fields/dropdown/DropdownBuilder.vue";
import LinearScaleBuilder from "@/components/form/fields/linear_scale/LinearScaleBuilder.vue";
import LongAnswerField from "@/components/form/fields/LongAnswerField.vue";
import RadioGroupBuilder from "@/components/form/fields/radio_group/RadioGroupBuilder.vue";
import TimePickerBuilder from "@/components/form/fields/time_picker/TimePickerBuilder.vue";
import DividerBuilder from "@/components/form/fields/divider/DividerBuilder.vue";
import {Question} from "@/api/types/Question";
import {Form} from "@/api/types/Form";
import ShortAnswerField from "@/components/form/fields/ShortAnswerField.vue";


export default Vue.extend({
  name: "QuestionBuilder",
  components: {
    ShortAnswerField,
    CheckboxGroupBuilder,
    DatePickerBuilder,
    DropdownBuilder,
    LinearScaleBuilder,
    LongAnswerField,
    RadioGroupBuilder,
    TimePickerBuilder,
    DividerBuilder,
    draggable,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {
          title: "",
          description: "",
          photoUrl: "",
          questions: [
            {
              title: "",
              type: "text-field",
              required: false,
              options: [""],
              extraValidations: false,
              validation: "",
              scoreList: [],
              linearScale: {
                minValue: 0,
                maxValue: 1,
                minLabel: "",
                maxLabel: "",
              },
              position: 0,
              image: {
                file: null,
                deleting: false,
                deleteUrl: null
              }
            },
          ] as Partial<Question>[],
          score: false as boolean,
          tenantIds: [] as string[]
        } as Partial<Form>
      }
    }
  },
  data() {
    return {
      editedForm: this.value,
      fileError: false as boolean,
      fileErrorMessage: "" as string,
    };
  },
  methods: {
    getImageUrl(imageUrl: string) {
      if (imageUrl.split(':')[0] === 'blob') {
        return imageUrl;
      }
      const api_url = process.env.VUE_APP_API_URL;
      return `${api_url}/files/${imageUrl}`;
    },
    deleteQuestion(index: number): void {
      this.editedForm.questions?.splice(index, 1);
    },
    copyQuestion(index: number, item: any): void {
      this.$emit("add", index, item);
      let newQuestion = Object.assign({}, item)
      delete newQuestion.id;
      newQuestion.keyId = uuid();
      this.editedForm.questions?.splice(index + 1, 0, newQuestion);
    },
    emitClear() {
      this.$emit("clear");
    },
    changedScores(value: Array<number>, index: number) {
      this.editedForm.questions[index].scoreList = value;
    },
    async addFile(index: number) {
      const re = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png|\.webp|\.tif)$/i;
      if (this.editedForm.questions[index].image.file.size / 1024 / 1024 > 5) {
        this.editedForm.questions[index].image.file = null;
        this.editedForm.questions[index].imageUrl = null;
        this.fileErrorMessage = this.$t('forms.form.validations.fileSizeError').toString();
        this.fileError = true;
      } else if (!re.exec(this.editedForm.questions[index].image.file.name)) {
        this.editedForm.questions[index].image.file = null;
        this.editedForm.questions[index].imageUrl = null;
        this.fileErrorMessage = this.$t('forms.form.validations.fileUnsupportedFile').toString();
        this.fileError = true;
      } else {
        this.editedForm.questions[index].imageUrl = URL.createObjectURL(this.editedForm.questions[index].image.file);
      }
    },
    deleteImage(index: number) {
      this.editedForm.questions[index].image.file = null;
      if (!this.editedForm.questions[index].imageUrl.includes('blob:')) {
        this.editedForm.questions[index].image.deleting = true;
        this.editedForm.questions[index].image.deleteUrl = this.editedForm.questions[index].imageUrl;
      }
      this.editedForm.questions[index].imageUrl = '';
    },
    openFileUpload(index: number) {
      // eslint-disable-next-line
      const input: any = this.$refs[`imageFileInput-${index}`];
      if (input && input.length > 0) {
        input[0].$refs.input.click();
      }

    },
    toggleExpandQuestion(question: Question) {
      if(question.expanded === 0) question.expanded = -1
      else question.expanded = 0;
      this.$forceUpdate();
    }
  },
  watch: {
    editedForm: function (form) {
      this.editedForm = form;
      this.$emit("input", form);
    },
    value: function (value) {
      this.editedForm = value;
    },
  },
  computed: {
    extraValidations: {
      set() {
        return [];
      },
      get() {
        return [
          {value: 'email', text: this.$t('forms.form.validations.options.email')},
          {value: 'phone', text: this.$t('forms.form.validations.options.phone')},
          {value: 'rut', text: this.$t('forms.form.validations.options.rut')},
          // this.$t('forms.form.validations.options.regex'),
        ]
      }
    },
    questionTypeComponent: {
      set() {
        return [];
      },
      get() {
        return {
          'text-field': {
            'is': 'short-answer-field',
            label: this.$t('forms.form.fields.shortAnswerText'),
            disabled: true,
            hasModel: false,
          },
          'text-area': {
            'is': 'long-answer-field',
            label: this.$t('forms.form.fields.longAnswerText'),
            disabled: true,
            hasModel: false,
          },
          'radio-group': {
            'is': 'radio-group-builder',
            label: this.$t('forms.form.fields.optionText'),
            optionLabel: this.$t('forms.form.fields.addOption'),
            scoreLabel: this.$t('forms.form.fields.scoreLabel'),
            disabled: true,
            hasModel: true,
            score: this.value.score,
            model: 'options'
          },
          'checkbox': {
            'is': 'checkbox-group-builder',
            label: this.$t('forms.form.fields.optionText'),
            optionLabel: this.$t('forms.form.fields.addOption'),
            scoreLabel: this.$t('forms.form.fields.scoreLabel'),
            disabled: true,
            hasModel: true,
            score: this.value.score,
            model: 'options'
          },
          'select': {
            'is': 'dropdown-builder',
            label: this.$t('forms.form.fields.optionText'),
            optionLabel: this.$t('forms.form.fields.addOption'),
            scoreLabel: this.$t('forms.form.fields.scoreLabel'),
            disabled: true,
            hasModel: true,
            score: this.value.score,
            model: 'options'
          },
          'linear-scale': {
            'is': 'linear-scale-builder',
            labelFrom: this.$t('forms.form.fields.from'),
            labelTo: this.$t('forms.form.fields.to'),
            labelTextFrom: this.$t('forms.form.fields.labelFrom'),
            labelTextTo: this.$t('forms.form.fields.labelTo'),
            disabled: true,
            hasModel: true,
            model: 'linearScale'
          },
          'date-input': {
            'is': 'date-picker-builder',
            label: this.$t('forms.form.fields.date'),
            disabled: true,
            hasModel: false,
          },
          'time-input': {
            'is': 'time-picker-builder',
            label: this.$t('forms.form.fields.time'),
            disabled: true,
            hasModel: false,
          },
          'divider': {
            'is': 'divider-builder',
            label: this.$t('forms.form.fields.section'),
            disabled: true,
            hasModel: false,
          }
        }
      }
    },
    questionOptions: {
      set() {
        return [];
      },
      get() {
        return [
          {
            name: this.$t("forms.form.questions.shortAnswer"),
            value: "text-field",
            icon: "mdi-text-short",
          },
          {
            name: this.$t("forms.form.questions.paragraph"),
            value: "text-area",
            icon: "mdi-text-long",
          },
          {
            name: this.$t("forms.form.questions.multipleChoice"),
            value: "radio-group",
            icon: "mdi-order-bool-descending",
          },
          {
            name: this.$t("forms.form.questions.checkboxes"),
            value: "checkbox",
            icon: "mdi-order-bool-descending-variant",
          },
          {
            name: this.$t("forms.form.questions.dropdown"),
            value: "select",
            icon: "mdi-arrow-down-drop-circle",
          },
          {
            name: this.$t("forms.form.questions.linearScale"),
            value: "linear-scale",
            icon: "mdi-ray-start-vertex-end",
          },
          {
            name: this.$t("forms.form.questions.date"),
            value: "date-input",
            icon: "mdi-calendar",
          },
          {
            name: this.$t("forms.form.questions.time"),
            value: "time-input",
            icon: "mdi-clock-outline",
          },
          {
            name: this.$t("forms.form.questions.section"),
            value: "divider",
            icon: "mdi-format-title",
          },
        ];
      },
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
});
